// Author thq
// Date 2021-11-25 14:42:05

import * as model from "@/model/em/spareparts/EmSppSparePartsSpaModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppSparePartsSpa(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .buildStore()
